// extracted by mini-css-extract-plugin
module.exports = {"assessment-item":"AssessmentItem_assessment-item__2_Hqc","assessment":"AssessmentItem_assessment__2Ihbb","timestamp":"AssessmentItem_timestamp__oK0dA"};